import './whyBankWithUs.css'
import React from "react";
import growth from "../../assets/images/IZB/IZB Website Skin/Why bank with us/icons/growth.png";
import Fingerprint from "../../assets/images/IZB/IZB Website Skin/Why bank with us/icons/fingerprint.png";
import Shield from "../../assets/images/IZB/IZB Website Skin/Why bank with us/icons/shield.png";
import AllAcountsSection from "../AllAccountsSection/AllAcountsSection";

const Img1 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-mod-1.png'
const Img2 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-mod-2.png'
const Img3 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-new-mod-3.png'
const Img4 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-mod-4.png'
const Img5 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-mod-5.png'
const Img6 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-mod-6.png'

const Img7 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-7.png'
const Img8 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-8.png'
const Img9 = 'https://izbassetsmain.blob.core.windows.net/izbwebassets/why-bank-with-us-card-9.png'

const WhyBankWithUsComponents = () => {
  return (
    <>
    <section>
      <div className="container">
        <div className="text-center mb-5">
          <h2>Why Bank With Us</h2>
        </div>
        
        <div className="row whyBankWithUsCards">
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img1} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p>Strong capital position, which provides a good base to expand its business.</p>
                </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img2} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p>Public owned institution with a strong brand makes the Bank appealing and adds to its safety and stability.</p>
                </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img3} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p>Professional and experienced team of highly qualified and skilled management team with a multicultural makeup. A youthful workforce.</p>
                </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img4} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p>Steady and organic growth for 40 years leading to growing customer confidence with a sound governance structure and shareholders' good will.</p>
                </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img5} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p>Extensive branch network covering all provinces providing a base to further support a network of agencies and other alternative delivery channels.</p>
                </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img6} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p>Advanced ICT infrastructure with tested, competitive and cost-effective products.</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div className="container">
        <div className="text-center mb-5">
          <h2>About Indo Zambia Bank</h2>
        </div>
        
        <div className="row whyBankWithUsCards AboutUsUpdated">
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img7} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p className='img-text-card_text-title'>Growth</p>
                  <p>Your Money grows with us, as returns are assured As a bank we are growing at the rate of 25%. We have a national branch network coverage of 40 branches. We are enabling the growth of the economy by promoting financial inclusion especially for women.</p>
                </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img8} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p className='img-text-card_text-title'>Safety</p>
                  <p>A bank with impeccable and consistent record of excellent performance under all major financial parameters for the last 41 years; A bank which has unique shareholding pattern with participation of two governments; the government of the republic of Zambia through industrial development corporation and the government of India.</p>
                </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-xl-4">
            <div className="img-text-card">
                <div className="img-text-card_banner">
                  <img src={Img9} alt="" srcset="" />
                </div>
                <div className="img-text-card_text">
                  <p className='img-text-card_text-title'>Human Touch</p>
                  <p>A technology - driven bank with a personal touch, we are committed to building string and lasting relationships with our customers. Guided by ingenuity and flexibility, we craft tailored financial solutions that go beyond expectations. At Indo Zambia Bank , we offer the expertise you seek and the service you deserve, ensuring a seamless and rewarding banking experience.</p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section>
      <AllAcountsSection />
    </section>
    </>
  );
};

export default WhyBankWithUsComponents;
